export default {"src":"/_next/static/media/Intro.5c348455.gif","height":680,"width":680,"blurWidth":0,"blurHeight":0};